import React, { useEffect } from 'react'

import Text from 'components/Text'
import TextButton from 'components/Buttons/TextButton'

import { colors } from 'utils/colors'

import { getAutoGeneratedMessage, VARIANTS } from './helper'
import { Container, ContentWrapper, StyledIcon, DismissButton, DismissButtonWrapper } from './styles'
import { AutoGenerateMessage, IToastProps, MessageRequired } from './types'

const ToastMessage = (props: IToastProps) => {
  const {
    variant = 'error',
    noticeKey,
    onClose,
    duration = 5,
    hasDismiss,
    hasIcon = true,
    actionName,
    action,
    withoutTimeOut,
  } = props

  const message = (props as MessageRequired).message || getAutoGeneratedMessage(props as AutoGenerateMessage)

  const { color, icon } = VARIANTS[variant]
  let closeTimer: number | null

  const startTimer = () => {
    closeTimer = window.setTimeout(() => {
      close()
    }, duration * 1000)
  }

  const clearCloseTimer = () => {
    if (closeTimer) {
      clearTimeout(closeTimer)
      closeTimer = null
    }
  }

  const close = (e?: React.MouseEvent<HTMLAnchorElement>) => {
    if (e) {
      e.stopPropagation()
    }
    clearCloseTimer()
    onClose({ noticeKey })
  }

  useEffect(() => {
    if (withoutTimeOut) {
      return
    }

    if (closeTimer) {
      clearCloseTimer()
    }

    startTimer()

    return () => clearCloseTimer()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Container color={color as keyof typeof colors}>
      <ContentWrapper>
        {hasIcon && <StyledIcon color="white" fontSize={16} icon={icon} />}
        <Text color="white" fontSize={14} fontWeight="bold">
          {message}
        </Text>
      </ContentWrapper>
      <ContentWrapper>
        {actionName && (
          <TextButton margin={15} onClick={() => action?.()}>
            <Text color="white" fontSize={14} fontWeight="bold">
              {actionName}
            </Text>
          </TextButton>
        )}
        {hasDismiss && (
          <DismissButtonWrapper>
            <DismissButton icon="times" onClick={close} />
          </DismissButtonWrapper>
        )}
      </ContentWrapper>
    </Container>
  )
}

export default ToastMessage
